import * as SURVEY_CONSTANTS from '@/components/content/HdmAditionalInfo/parts/constants_surveymonkey';

export const buildSurveyPayload = (params: {
	message: string;
	issueType?: string;
	subIssueId?: string;
	skuNumber?: string;
	productTitle?: string;
	departmentPDP?: string;
}) => {
	const { message, skuNumber, productTitle, departmentPDP } = params;
	return {
		pages: [
			{
				id: SURVEY_CONSTANTS.PAGE_ID_FEEDBACK,
				questions: [
					{
						id: SURVEY_CONSTANTS.QUESTION_ID_SATISFACTION,
						answers: [
							{
								choice_id: SURVEY_CONSTANTS.CHOICE_ID_SATISFIED,
							},
						],
					},
					{
						id: SURVEY_CONSTANTS.QUESTION_ID_OTHER_FEEDBACK,
						answers: [
							{
								other_id: SURVEY_CONSTANTS.OTHER_ID_FEEDBACK,
								text: message,
							},
						],
					},
					{
						id: SURVEY_CONSTANTS.QUESTION_ID_MESSAGE,
						answers: [
							{
								text: message,
							},
						],
					},
					{
						id: SURVEY_CONSTANTS.QUESTION_ID_SKU,
						answers: [
							{
								text: skuNumber || SURVEY_CONSTANTS.NOTAPPLY,
							},
						],
					},
					{
						id: SURVEY_CONSTANTS.QUESTION_ID_PRODUCT_TITLE,
						answers: [
							{
								text: productTitle?.toLowerCase() || SURVEY_CONSTANTS.NOTAPPLY,
							},
						],
					},
					{
						id: SURVEY_CONSTANTS.QUESTION_ID_DEPARTMENT,
						answers: [
							{
								text: departmentPDP || SURVEY_CONSTANTS.NOTAPPLY,
							},
						],
					},
				],
			},
		],
	};
};
